import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { SignupCTA } from "./SignupCTA";

const CTA_MARKER = "[[CTA]]";

const Md = ({ children }) => <ReactMarkdown remarkPlugins={[remarkGfm]}>{children}</ReactMarkdown>;

export const Markdown = ({ content = "", withCta = false }) => {
  const parts = content.split(CTA_MARKER);
  return (
    <div className="trackr-prose" data-testid="blog-post-content">
      {parts.map((part, i) => (
        <div key={i}>
          <Md>{part}</Md>
          {withCta && i < parts.length - 1 && <SignupCTA variant="inline" />}
        </div>
      ))}
    </div>
  );
};
